

angular
.module('inkfinder')
.factory('Appointment', function Appointment(
  $http,
  ENDPOINT,
  Project,
  Session,
  moment,
  AlertMessages,
  FormatProject,
  FormatAppointment,
  AppointmentApiFormat,
  _
) {
  // Public Functions
  Appointment.get = get;
  Appointment.create = create;
  Appointment.update = update;

  /**
   * @name get
   * @description Function to retrieve a single appointment from the API.
   * @param {number} appointmentId The ID of the appointment to retrieve.
   * @param {number} timestamp The ID of the appointment to retrieve.
   * @return {promise} Returns a promise from the $http.
   */
  function get(appointmentId, timestamp) {
    let role = Session.activeState.role;
    let associationId;
    if (!_.isUndefined(Session.activeState.association)) {
      associationId = Session.activeState.association.id;
    }
    return $http.get(ENDPOINT.server +
    'appointments/api/v1.1/' + appointmentId + '/' +
    '?role=' + role +
    (associationId ? ('&association_id=' + associationId) : ''))
    .then(function(response) {
      return FormatAppointment.format(response.data);
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }

  /**
   * @name create
   * @description Function to create an appointment
   * @param {object} input The appointment data
   * @param {Unknown} status Unknown
   * @return {object} Returns the new appointment
   */
  function create(input, status) {
    if (!status) {
      status = null;
    }
    // Association ID and role are being added in the format function
    let appointment = AppointmentApiFormat.format(input, status);
    return $http.post(ENDPOINT.server + 'appointments/api/v1.1/', appointment)
    .then(function(response) {
      return FormatAppointment.format(response.data);
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }

  /**
   * @name update
   * @description Function to update an appointment
   * @param {object} input The appointment data
   * @param {Unknown} status Unknown
   * @return {object} Returns the updated appointment.
   */
  function update(input, status) {
    // Association ID and role are being added in the format function
    let appointment = AppointmentApiFormat.format(input, status);
    return $http.put(ENDPOINT.server +
    'appointments/api/v1.1/' + appointment.id + '/', appointment)
    .then(function(response) {
      return FormatAppointment.format(response.data);
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }
  return Appointment;
});



// WEBPACK FOOTER //
// ./components/appointments/appointment/appointment.service.js